import { useTranslation } from "react-i18next";
import { useToast } from "../../modules/layout/components/ToastContext";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { update } from "../_request";

interface UnlockUserProps{
    targetProfileId: string;
    isDisabled: boolean;
    onSuccess: ()=> void;
}

export default function UnlockUser({targetProfileId, isDisabled, onSuccess}: UnlockUserProps) {

    const { t } = useTranslation();
    const { showToast } = useToast();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);
    const [open, setOpen] = useState(false);

    const handleUnlock = async () =>{
        setLoading(true);
        setError(null);
        setSuccess(false);

        try{
            setLoading(true);

            const params = new URLSearchParams({ targetProfileId });

            const result: any = await update(`/api/UserEvents/UnlockUser?${params.toString()}`, null);
            const respStatus = result?.status ?? result?.response?.status;

            if (respStatus === 200 || respStatus === 204 || respStatus === undefined){
                showToast && showToast(t("ProfileUnlockedSuccessfully"), 'success');
                onSuccess();
            } else if (respStatus === 401) {
                navigate('/auth/login');
            } else if (respStatus === 403) {
                navigate('/error/403'); 
            } else if (respStatus === 404) {
                showToast && showToast(t('ProfileNotfound'), 'error');
            } else if (respStatus === 500) {
                navigate('/error/500');
            } else {
                showToast && showToast(t('StatusCode', { code: String(respStatus)}), 'error');               
            }
        } catch (err: any) {
            console.error(err);
            showToast && showToast(t('ConnectionError', { error: String(err)}), 'error');
        } finally {
            setLoading(false);
            setOpen(false);
        }
    }

    return(
        <>
            <button className="btn gg-btn me-2" onClick={() => setOpen(true)} disabled={isDisabled}>
                {t('UnlockUser')}
            </button>

            {open && (
                <div className="gg-modal-overlay">
                    <div className="gg-modal">
                        <div className="gg-modal-header">
                            <h5 className="mb-0">
                                {t('UnlockUser')}
                            </h5>
                        </div>

                        <div className="gg-modal-body">
                            <p className="text-muted small mb-0">
                                {t('ApprovingWillUnlockUser')}
                            </p>
                        </div>

                        <div className="gg-modal-footer">
                            <button className="gg-btn" onClick={() => setOpen(false)} disabled={loading}>
                                {t('Cancel')}
                            </button>

                            <button className="btn btn-secondary text-white" onClick={handleUnlock} disabled={loading}>
                                {loading ? t('Approving') : t('Confirm')}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}